import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { getSellerIdentityLabels, normalizeSellerHandle } from '../../utils/sellerIdentityDisplay';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.5rem;
`;

const RowLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  color: inherit;

  &:hover {
    opacity: 0.92;
  }
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  font-weight: 700;
  border: 2px solid #e2e8f0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const TextWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem;
  font-size: 0.9rem;
`;

const SellerName = styled.span`
  font-weight: 600;
  color: var(--text-primary, #0f172a);
`;

const SellerUsername = styled.span`
  color: var(--primary-color, #0f766e);
  font-weight: 500;
`;

const SellerIdentityRow = ({
  name,
  username,
  profilePicture,
}) => {
  const { primary, secondary } = getSellerIdentityLabels(name, username);
  if (!primary && !secondary) return null;

  const initial = (primary || secondary || '?').replace(/^@/, '').charAt(0).toUpperCase();
  const profilePath = username ? `/u/${encodeURIComponent(normalizeSellerHandle(username))}` : null;

  const content = (
    <>
      <Avatar>
        {profilePicture ? <img src={profilePicture} alt="" /> : initial}
      </Avatar>
      <TextWrap>
        {primary ? (
          secondary ? <SellerName>{primary}</SellerName> : <SellerUsername>{primary}</SellerUsername>
        ) : null}
        {secondary ? <SellerUsername>{secondary}</SellerUsername> : null}
      </TextWrap>
    </>
  );

  if (profilePath) {
    return (
      <Row>
        <RowLink to={profilePath}>{content}</RowLink>
      </Row>
    );
  }

  return <Row>{content}</Row>;
};

export default SellerIdentityRow;
